import { ActionTree } from 'vuex';
import { ICreateTemplateState } from '@/content-library/create-resource/template/store/create-template.types';
import {
  ECreateTemplateAction,
  ECreateTemplateMutation,
  state as defaultState,
} from '@/content-library/create-resource/template/store/create-template.constants';
import { RootState } from '@/store/store';
import { DocumentService } from '@/api/documents/services/document.service';
import { translate } from '@/helpers/translation.helper';
import { EnumDocumentType } from '@/enums/DocumentType';
import dealroomService from '@/dealroom/services/dealroom.service';
import { IUpdateDocument } from '@/dealroom/document/types/update-document';

export const actions: ActionTree<ICreateTemplateState, RootState> = {
  async [ECreateTemplateAction.CreateTemplate]({ dispatch }, name: string) {
    try {
      const templateId: string = await DocumentService.createDocument(EnumDocumentType.Template);
      const payload: IUpdateDocument = { name };
      await dealroomService.updateDocument(payload, templateId);
      dispatch(ECreateTemplateAction.SetTemplateId, templateId);
    } catch (e) {
      dispatch(ECreateTemplateAction.CreateTemplateFailed);
    }
  },
  [ECreateTemplateAction.CreateTemplateFailed]({ dispatch }) {
    dispatch('alert/showDangerAlert', translate('failed-to-create-template'), {
      root: true,
    });
  },
  [ECreateTemplateAction.SetTemplateId]({ commit }, templateId: string) {
    commit(ECreateTemplateMutation.SetTemplateId, templateId);
  },
  [ECreateTemplateAction.Reset]({ commit }) {
    commit(ECreateTemplateMutation.SetState, defaultState);
  },
};
